import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import AdminPanel from "@/pages/AdminPanel";
import Squadre from "@/pages/Squadre";
import Onboarding from "@/pages/Onboarding";
import Fantascommesse from "@/pages/Fantascommesse";
import TeamPage from "@/pages/TeamPage";
import Privacy from "@/pages/Privacy";
import AlboDoro from "@/pages/AlboDoro";
import SupporterJoin from "@/pages/SupporterJoin";
import CookieBanner from "@/components/CookieBanner";
import InstallPrompt from "@/components/InstallPrompt";
import Confetti from "@/components/Confetti";
import PWASplash from "@/components/PWASplash";
import { GeneralStandings, GironiStandings } from "@/pages/Classifica";
import { CoppaFaseGirone, CoppaChampions, CoppaEuropa, CoppaPlayoff, CoppaOttaviChampions, CoppaOttaviEuropa } from "@/pages/Coppa";
import News from "@/pages/News";
import Aste from "@/pages/Aste";
import PerformancePage from "@/pages/Performance";
import Calendario from "@/pages/Calendario";
import Confronto from "@/pages/Confronto";

function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-slate-500">Caricamento...</div>;
  if (!user || !user.id) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin" element={<Protected admin><AdminPanel /></Protected>} />
            <Route path="/squadre" element={<Squadre />} />
            <Route path="/squadra/:userId" element={<TeamPage />} />
            <Route path="/fantascommesse" element={<Fantascommesse />} />
            <Route path="/campionato/classifica-generale" element={<GeneralStandings />} />
            <Route path="/campionato/classifica-gironi" element={<GironiStandings />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<News />} />
            <Route path="/aste" element={<Aste />} />
            <Route path="/performance" element={<PerformancePage />} />
            <Route path="/calciatori" element={<Navigate to="/performance" replace />} />
            <Route path="/coppa/fase-a-girone" element={<CoppaFaseGirone />} />
            <Route path="/coppa/maxi" element={<Navigate to="/coppa/fase-a-girone" replace />} />
            <Route path="/coppa/playoff" element={<CoppaPlayoff />} />
            <Route path="/coppa/ottavi" element={<CoppaOttaviChampions />} />
            <Route path="/coppa/europa-ottavi" element={<CoppaOttaviEuropa />} />
            <Route path="/coppa/champions" element={<CoppaChampions />} />
            <Route path="/coppa/europa" element={<CoppaEuropa />} />
            <Route path="/albo-doro" element={<AlboDoro />} />
            <Route path="/calendario" element={<Calendario />} />
            <Route path="/confronto" element={<Confronto />} />
            <Route path="/supporter/join/:token" element={<SupporterJoin />} />
            <Route path="/onboarding/:token" element={<Onboarding />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="light" richColors />
          <CookieBanner />
          <InstallPrompt />
          <Confetti />
          <PWASplash />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
